import { z } from 'zod';

import { ContractType, EmployeeStatus, JobHistoryLevel } from '@/common/graphql';

export const EmployeeDirectReport = z.object({
  employeeId: z.string().default(''),
  name: z.string().default(''),
  status: z.nativeEnum(EmployeeStatus).default(EmployeeStatus.Active),
  companyEmail: z.string().nullable().default(null),
  contractType: z.nativeEnum(ContractType).nullable().default(ContractType.FtPermanent),
  company: z.string().nullable().default(null),
  location: z.string().nullable().default(null),
  division: z.string().nullable().default(null),
  businessUnit: z.string().nullable().default(null),
  job: z.string().nullable().default(null),
  level: z.nativeEnum(JobHistoryLevel).nullable().default(JobHistoryLevel.L0),
  jobTitle: z.string().nullable().default(null),
  team: z.string().nullable().default(null),
});
export type EmployeeDirectReportType = z.infer<typeof EmployeeDirectReport>;
